<template>
  <div
    class="fixed inset-x-0 top-0 z-50 border-b border-primaryDark/20 bg-primaryAccent/95 px-4 py-2.5 text-center shadow-md backdrop-blur-sm sm:px-6"
    role="status"
  >
    <p class="text-sm font-medium text-white">{{ text }}</p>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  text: String,
})
</script>
